import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RMCategorySearch from "./RawMaterialCategories-Search";
import RMCategoryDatatable from "./RawMaterialCategory-Datatable";
import RawMaterialService from "../../../services/RawMaterials/RawMaterialService";

const RawMaterialCategoriesMainPage: React.FC = () => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedKeyword, setSelectedKeyword] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, [pageNo, pageSize, selectedKeyword]);

  const handlePageChange = (event: any) => {
    setPageNo(event.page + 1); // PrimeReact 0-based index
    setPageSize(event.rows);
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await RawMaterialService.getAllRMCategories({
        pageNo,
        pageSize,
        searchText: selectedKeyword || "",
      });

      setCategories(response?.rMcategory || []);
      setTotalRecords(response?.totalRecords || 0);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <div className="col-12">
        <h4 className="ml-1 mb-0">{t("Raw Material Category")}</h4>
      </div>

      <RMCategorySearch
        onSearch={(keyword) => {
          setSelectedKeyword(keyword);
          setPageNo(1); // reset to first page on search
        }}
        onAdded={fetchCategories}
      />

      <RMCategoryDatatable
        categories={categories}
        totalRecords={totalRecords}
        pageNo={pageNo}
        pageSize={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
        onUpdated={fetchCategories}
      />
    </div>
  );
};

export default RawMaterialCategoriesMainPage;
